const Tdata=[
    {
    "id": 1,
    "title": "Country of Europe",
    "price": 2500,
    "description": "Blue Ice Experience",
    "category": "1",
    "image": "https://demo.themexpert.com/wordpress/valley/travel-agency/wp-content/uploads/sites/2/2019/07/tour-1-1.png",
    },
    {
    "id": 2,
    "title": "Country of South America",
    "price": 4500,
    "description": "Glacier Walk Combo",
    "category": "2",
    "image": "https://demo.themexpert.com/wordpress/valley/travel-agency/wp-content/uploads/sites/2/2019/07/tour-2-1.png",
    },
    {
    "id": 3,
    "title": "Capital of France",
    "price":4500,
    "description": "Laugavegur Trek Classic",
    "category": "3",
    "image": "https://demo.themexpert.com/wordpress/valley/travel-agency/wp-content/uploads/sites/2/2019/07/tour-3-1.png",
    },
    {
        "id": 4,
        "title": "Country of Europe",
        "price": 2500,
        "description": "The Greenland Trek",
        "category": "1",
        "image": "https://demo.themexpert.com/wordpress/valley/travel-agency/wp-content/uploads/sites/2/2019/07/tour-4-1.png",
        },
]
export default Tdata;